module.exports = __webpack_public_path__ + "img/logo.bdc9aab7.png";